<template>
  <v-flex class="status-tab" :class="{ 'active': active.length && active.every(item => element.value.includes(item)) }" v-ripple @click.stop="changeState(element.value)">
    <button class="w-100">
      <template v-if="element.icon !== undefined">
        <v-icon small v-if="typeof element.icon !== 'object'" class="k-orange-linear-text">{{ element.icon }}</v-icon>
        <span class="fa-stack fa-1x" v-else>
          <i class="k-orange-linear-text far fa-stack-1x" :class="{ [`fa-${element.icon.first}`]: true }"></i>
          <i class="k-orange-linear-text fas fa-stack-halfx" :class="{ [`fa-${element.icon.second}`]: true }"></i>
        </span>
      </template>
      {{ element.text }}
      <small>
        ({{ element.qty }})
      </small>
    </button>
  </v-flex>
</template>
<script>
export default {
  props: {
    active: {
      type: Array,
      default: () => [],
    },
    element: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    changeState(value) {
      if (Object.prototype.hasOwnProperty.call(this.element, 'active')) {
        this.element.active = !this.element.active;
      } else {
        this.$emit('changed', value);
      }
    },
  },
};
</script>
<style scoped>
  .fa-stack.fa-1x {
    height: 1em;
    font-size: 8px;
    line-height: 1em;
  }
  .fa-stack-1x {
    font-size: 16px;
  }
  .fa-stack-halfx {
    font-size: 8px;
  }
  .status-tab {
    cursor: pointer;
    position: relative;
  }
  .status-tab:after {
    left: 50%;
    width: 0%;
    height: 5px;
    bottom: 0px;
    content: '';
    position: absolute;
    background-color: #f57a64;
    transform: translateX(-50%);
    transition: .125s width ease-in;
  }
  .status-tab.active:after {
    width: 80%;
  }
  .status-tab > button:focus {
    outline: none;
  }
</style>




// WEBPACK FOOTER //
// src/components/chat_center_v2/StatusBtn.vue